// extracted by mini-css-extract-plugin
export default {"informationIcon":"Makepayment_informationIcon__ahtMC"};